import { render, staticRenderFns } from "./profileMenu.vue?vue&type=template&id=ae3532e8&scoped=true&lang=html&"
import script from "./profileMenu.vue?vue&type=script&lang=js&"
export * from "./profileMenu.vue?vue&type=script&lang=js&"
import style0 from "./profileMenu.vue?vue&type=style&index=0&id=ae3532e8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3532e8",
  null
  
)

export default component.exports